interface ParamsMap {
    [key: string]: string;
}

export class UtmService {
    readonly UTMCookiePrefix = 'utm_';
    readonly b2bUTMConverted = 'b2b_utm_converted';
    readonly b2bUTMOriginal = 'b2b_utm_original';
    readonly b2bUTMCookiePath = ';path=/';
    readonly b2bUTMCookieMaxAge = ';max-age=31536000';
    readonly UTMParamsShortNamesMap = {
        'utm_campaign': 'utmccn',
        'utm_content': 'utmcct',
        'utm_medium': 'utmcmd',
        'utm_source': 'utmcsr',
        'utm_term': 'utmctr'
    }
    readonly QueryParamCatchList = [
        'b2b_utm_converted',
        'b2b_utm_original',
        'b2c_utm_original',
    ];

    public checkBeforeStoreCookies(searchParams: string) {
        let queryParams = '';
        if (searchParams.indexOf('?') !== -1 && searchParams.substring(1).indexOf('=') !== -1) {
            queryParams = searchParams.substring(1);
        } else {
            return;
        }

        const urlQueryStringParams: ParamsMap = this.parseSearchString(queryParams);
        this.catchQueryParamsToCookies(urlQueryStringParams);

        if (this.hasCookie(this.b2bUTMConverted)) {
            if (this.hasCookie(this.b2bUTMOriginal)) {
                this.storeUTMConvertedCookie(urlQueryStringParams, this.b2bUTMConverted);
            } else {
                this.swapConvertedToOriginalCookies(urlQueryStringParams);
            }
        } else {
            this.storeUTMConvertedCookie(urlQueryStringParams, this.b2bUTMConverted);
        }
    }

    private parseSearchString(queryParams: string): ParamsMap {
        const params = new URLSearchParams(queryParams);
        const result: ParamsMap = {};
        params.forEach((value, key) => {
            result[key] = value;
        });
        return result;
    }

    private hasUTMTags(params: ParamsMap) {
        return Object.keys(params).some(key => this.isUTMCookie(key));
    }

    private isUTMCookie(key) {
        return key.startsWith(this.UTMCookiePrefix) && this.UTMParamsShortNamesMap[key];
    }

    private shouldCopyQueryToCookie(key: string) {
        return this.QueryParamCatchList.indexOf(key) > -1;
    }

    private convertUTMQueryParams(urlQueryStringParams: ParamsMap) {
        const convertedUTMQueryParamsArray = Object.keys(urlQueryStringParams).map((key) => {
            if (this.isUTMCookie(key)) {
                return this.UTMParamsShortNamesMap[key].concat('=', encodeURIComponent(urlQueryStringParams[key]), '|');
            }
        });
        return convertedUTMQueryParamsArray.sort().join('').slice(0, -1);
    }

    private hasCookie(cookie: string): boolean {
        return document.cookie.indexOf(cookie) !== -1;
    }

    private storeUTMConvertedCookie(urlQueryStringParams: ParamsMap, cookieName: string) {
        if (this.hasUTMTags(urlQueryStringParams)) {
            document.cookie =
                `${cookieName}=${this.convertUTMQueryParams(urlQueryStringParams)}${this.b2bUTMCookiePath}${this.b2bUTMCookieMaxAge}`
        }
    }

    private storeUTMOriginalCookie(currentB2bConvertedCookie: string): void {
        document.cookie = `${this.b2bUTMOriginal}=${currentB2bConvertedCookie}${this.b2bUTMCookiePath}${this.b2bUTMCookieMaxAge}`;
    }

    private establishConvertedCookiesChanges(urlQueryStringParams: ParamsMap, currentB2bConvertedCookie: string) {
        if (!this.hasUTMTags(urlQueryStringParams)) {
            return false;
        }
        const newB2bConvertedCookie = this.convertUTMQueryParams(urlQueryStringParams);
        return newB2bConvertedCookie.replaceAll('%20', '') !== currentB2bConvertedCookie.replaceAll('%20', '');
    }

    private swapConvertedToOriginalCookies(urlQueryStringParams: ParamsMap) {
        const currentB2bConvertedCookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${this.b2bUTMConverted}=`))
            .replace(`${this.b2bUTMConverted}=`, '');
        if (this.establishConvertedCookiesChanges(urlQueryStringParams, currentB2bConvertedCookie)) {
            this.storeUTMOriginalCookie(currentB2bConvertedCookie);
            this.storeUTMConvertedCookie(urlQueryStringParams, this.b2bUTMConverted);
        }
    }

    private catchQueryParamsToCookies(urlQueryStringParams: ParamsMap): void {
        Object.keys(urlQueryStringParams).map((key) => {
            if (this.shouldCopyQueryToCookie(key)) {
                document.cookie = `${key}=${urlQueryStringParams[key]}${this.b2bUTMCookiePath}${this.b2bUTMCookieMaxAge}`
            }
        });
    }
}
(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.utmService = new UtmService();
(<any>window).skyComponents.utmService.checkBeforeStoreCookies(window.location.search);
